export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SET_NOTIFICATION_LIST_OPTIONS = 'SET_NOTIFICATION_LIST_OPTIONS';
export const SET_UNREAD_NOTIFICATIONS = 'SET_UNREAD_NOTIFICATIONS';
export const CLEAR_UNREAD_NOTIFICATIONS = 'CLEAR_UNREAD_NOTIFICATIONS';
